<template>
  <a-modal
    v-model:open="visible"
    title="用户详情"
    :footer="null"
    width="600px"
  >
    <DetailView
      v-if="user"
      :data="user"
      :sections="sections"
    >
      <template #field-roles="{ value }">
        <template v-if="value?.length">
          <a-tag v-for="r in value" :key="r.id" class="mr-1">{{ r.name }}</a-tag>
        </template>
        <span v-else>-</span>
      </template>
      
      <template #field-status="{ value }">
        <StatusTag :status="value" type="user" />
      </template>
      
      <template #field-language="{ value }">
        <LanguageTag v-if="value" :code="value" />
        <span v-else>-</span>
      </template>
      
      <template #field-last_login_at="{ value }">
        {{ value ? formatDateTime(value) : '从未登录' }}
      </template>
      
      <template #field-created_at="{ value }">
        {{ formatDateTime(value) }}
      </template>
      
      <template #field-updated_at="{ value }">
        {{ formatDateTime(value) }}
      </template>
      
      <template #field-is_active="{ value, record }">
        <a-tag :color="record?.status === 'active' ? 'green' : 'red'">
          {{ record?.status === 'active' ? '是' : '否' }}
        </a-tag>
      </template>
    </DetailView>
  </a-modal>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { DetailView, StatusTag, LanguageTag } from '@/shared/components'
import type { DetailSection } from '@/shared/components'
import { formatDateTime } from '@/shared/utils'
import type { UserInfo } from '../api'

interface Props {
  visible: boolean
  user: UserInfo | null
}

interface Emits {
  (e: 'update:visible', visible: boolean): void
}

const props = defineProps<Props>()
const emit = defineEmits<Emits>()

const visible = computed({
  get: () => props.visible,
  set: (val) => emit('update:visible', val)
})

const sections: DetailSection[] = [
  {
    title: '基本信息',
    type: 'descriptions',
    column: 2,
    fields: [
      { key: 'username', label: '用户名', type: 'text' },
      { key: 'email', label: '邮箱', type: 'text' },
      { key: 'name', label: '姓名', type: 'text' },
      { key: 'name_remark', label: '备注姓名', type: 'text' },
      { key: 'nationality', label: '国籍', type: 'text' },
      { key: 'language', label: '语种', type: 'custom' },
      { key: 'school', label: '所属院校', type: 'text' },
      { key: 'department', label: '所属学院', type: 'text' },
      { key: 'phone', label: '电话', type: 'text' },
      { key: 'roles', label: '角色', type: 'custom' },
      { key: 'status', label: '状态', type: 'custom' },
      { key: 'is_active', label: '是否激活', type: 'custom', span: 1 },
      { key: 'last_login_at', label: '最后登录时间', type: 'custom', span: 2 },
      { key: 'created_at', label: '创建时间', type: 'custom' },
      { key: 'updated_at', label: '更新时间', type: 'custom' }
    ]
  }
]

</script>

